import {DocumentExtractionBehaviour} from '../types/DocumentExtractionBehaviour';

export const STRUCTURED_INVOICE_BEHAVIOUR: DocumentExtractionBehaviour = {
  mode: 'structuredInvoice',
  isDocumentPreviewVisible: false,
  areSourceItemsReadOnly: true,
  allowZeroPrices: true,
  priceDecimalPlaces: 8,
  isArticlePrefillEnabled: false,
  isPriceRecalculationEnabled: false,
  isDocumentIdentityLocked: true,
  preservesDocumentCurrency: true,
  clearsWarehouseOnSupplierChange: true,
};
